import React from "react";

export default function ReferenceFeedbackPresentation({
  heading = "Reference feedback",
  headingHelp = null,
  introduction = null,
  items = [],
  target = null,
  footer = null,
  ariaLabel = "Expert reference feedback",
  className = "",
}) {
  return <section
    aria-label={ariaLabel}
    className={`av-expert-band-feedback ${className}`.trim()}
    data-presentation-owner="reference-feedback-presentation"
  >
    <h3>{heading} {headingHelp}</h3>
    {target && <div className="av-expert-band-feedback__target" aria-label="Target voice replay">{target}</div>}
    {introduction}
    {items.map(item => <article
      aria-label={item.ariaLabel || `${item.parameter} reference feedback`}
      className={`av-expert-band-feedback__parameter ${item.className || ""}`.trim()}
      key={item.key || item.parameter}
    >
      <h4 className="av-expert-band-feedback__parameter-heading" id={item.headingId}>{item.parameter}</h4>
      {item.content}
    </article>)}
    {footer}
  </section>;
}
